import Button from '@gaia/components/Button';
import RegistrationForm from '@gaia/components/RegistrationForm';
import theme from '@gaia/theme';
import fetchJSON from '@gaia/utils/fetchJSON';
import {ampli} from '@gaia/utils/gaia/trackAnalytics';
import {useCallback} from 'react';

async function postUserActivities(selectedActivities: string[]) {
    // post users activities to save them to user object
    return fetchJSON('/api/user/activities/', {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({
            activities: selectedActivities,
        }),
    });
}

// Sign Up Call To Action Card - part of anonymous user onboarding experiment. Displays sign up form with call to sign up and save progress
export default function SignUpCTA({
    setStepCount,
    onExitOnboarding,
    selectedActivities,
}: {
    setStepCount: SetState<number>;
    selectedActivities: string[];
    onExitOnboarding: () => void;
}) {
    const onUserAuthenticated = useCallback(() => {
        ampli.finishWebOnboarding();
        if (selectedActivities) {
            postUserActivities(selectedActivities).catch(console.warn);
        }
        onExitOnboarding();
    }, [onExitOnboarding, selectedActivities]);

    return (
        <>
            <div
                style={{
                    marginTop: theme.spacing(4),
                    marginBottom: theme.spacing(3),
                    marginLeft: theme.spacing(2),
                    marginRight: theme.spacing(2),
                }}
            >
                <RegistrationForm
                    nextPage={window.location.pathname}
                    onUserAuthenticated={onUserAuthenticated}
                    analyticsContext={'web onboarding'}
                    callToAction={'Sign Up Now and Save Your Progress'}
                    hideLoginLink
                />
            </div>
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'flex-start',
                    marginTop: theme.spacing(2),
                }}
            >
                <Button
                    appearance='secondary'
                    onClick={() => setStepCount((prevState: number) => prevState - 1)}
                >
                    Back
                </Button>
            </div>
        </>
    );
}
